import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_SERVER;
if (!API) {
  throw new Error('REACT_APP_BACKEND_SERVER no está definida. Revisá el .env y reiniciá npm start.');
}

const http = axios.create({ baseURL: `${API}/info`, timeout: 15000 });

// Si esta persona ya entró al tablero de dirección en este navegador, el token
// viaja y le deja ver los borradores. Es lo que permite que el docente revise
// un caso antes de que exista públicamente.
http.interceptors.request.use(cfg => {
  try {
    const t = localStorage.getItem('cvdl_admin_token');
    if (t) cfg.headers['x-cvdl-admin'] = t;
  } catch { /* modo privado */ }
  return cfg;
});

http.interceptors.response.use(r => r, err => {
  const e = new Error(err.response?.data?.message || err.message);
  e.code = err.response?.data?.error;
  e.status = err.response?.status;
  return Promise.reject(e);
});

// §6.3: "se puede salir y volver". El id de sesión vive en el teléfono y es lo
// único que identifica a quien no dejó datos. Si el navegador no deja guardar
// —modo privado—, se juega igual, sin poder retomar.
const CLAVE = 'forvet_caso_sesion';

export function idDeSesion() {
  try {
    let id = localStorage.getItem(CLAVE);
    if (!id) {
      id = (crypto.randomUUID?.() || `s-${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(CLAVE, id);
    }
    return id;
  } catch {
    return `efimera-${Date.now()}`;
  }
}

export const casosApi = {
  async listar() {
    const { data } = await http.get('/casos');
    return data;
  },
  async ver(slug, modo = 'short') {
    const { data } = await http.get(`/casos/${slug}`, { params: { modo } });
    return data;
  },
  async arrancar(slug, { mode, route }) {
    const { data } = await http.post(`/casos/${slug}/runs`, {
      sessionId: idDeSesion(), mode, route,
    });
    return data;
  },
  async decidir(runId, { stageId, key, ms }) {
    const { data } = await http.post(`/casos/runs/${runId}/decision`, { stageId, key, ms });
    return data;
  },
  async terminar(runId) {
    const { data } = await http.post(`/casos/runs/${runId}/final`);
    return data;
  },
  async identificar(runId, datos) {
    const { data } = await http.post(`/casos/runs/${runId}/identificar`, datos);
    return data;
  },
  async responder(runId, text) {
    const { data } = await http.post(`/casos/runs/${runId}/respuesta`, { text });
    return data;
  },
};
